﻿$(function () {
    $.CatalogTopFilter = {
        sort: 1,
        viewMode: 1,
        init: function () {
            // initSelect();
            // initCustomSelect();
            this.setEvents();
        },
        setEvents: function () {
            let context = this;
            $('body').on('change', '.category-sort', function (e) {
                context.sort = $(this).val();
                context.changeUrl();
            });

            $('body').on('click', '.viewtype-switch__item', function (e) {
                e.preventDefault();
                let viewType = $(this).data('viewtype');
                context.viewMode = viewType;
                SB.WriteCookie("VIEW_MODE", viewType, 9999);
                context.changeUrl();
            });

            $('body').on('change', '.b-catalog__filter-by-price > input[type=checkbox]', function () {
                context.changeUrl();
            });

            $('body').on('change', '.b-catalog__filter-by-sale > input[type=checkbox]', function () {
                context.changeUrl();
            });

            $('body').on('change', '.b-catalog__filter-by-sale-mobile > input[type=checkbox]', function () {
                context.changeUrl(true);
            });

            $('body').on('click', '.js-filter-toggle-btn', function (e) {
                e.preventDefault();
                $H.toggleClass('is-filters-opened');
            });

            $('body').on('change', '.sort-mobile-select__input', function () {
                const text = $(this).find('option:selected').text();
                $(this).parents('.js-sort-mobile-select')
                    .find('.sort-mobile-select__value')
                    .text(text);
                context.sort = $(this).val();
                context.changeUrl();
            });

            $('body').on('click', '.js-filter-params-popup-link', function () {
                $(this).parents('.js-filter-params')
                    .toggleClass('filter-params--popup')
                $(this).parents('.js-filter-params')
                    .find('.filter-params__list label.filter-params__item:gt(5)')
                    .toggleClass('filter-params__item--hidden');
            });

            $('body').on('click', '.js-filter-params-tag', function (e) {
                e.preventDefault();
                $(this).toggleClass('tag--active');
            });
            
            
            $("body").on('click', '.js-head-catalogbtn', function (e) {
                e.preventDefault();
                $(".sidebar-nav").toggleClass("is-shown");
            });
            
            $("body").on('click', '.js-catalog-close', function (e) {
                e.preventDefault();
                $(".sidebar-nav").toggleClass("is-shown");
            });
        },
        changeUrl: function (isMobile = false) {
            let url = new URL(window.location.href);
            url.searchParams.set('sort', this.sort);
            url.searchParams.set('view_mode', this.viewMode);
            let withPrice = document.querySelector('.b-catalog__filter-by-price > input[type=checkbox]').checked;
            let salePrice = isMobile 
                    ? document.querySelector('.b-catalog__filter-by-sale-mobile > input[type=checkbox]').checked 
                    : document.querySelector('.b-catalog__filter-by-sale > input[type=checkbox]').checked;
            // console.log(withPrice, salePrice);
            url.searchParams.set('r_0', withPrice ? '1-2147483647' : '0-2147483647');
            if (salePrice) {
                url.searchParams.set('sale', '1');
            } else {
                url.searchParams.delete('sale');
            }
            window.location = url;
        }
    };
});